import uuidv4 from 'uuid/v4';

import { dispatchPromise, fetchResources } from './action-helpers';

const DEFAULT_ACCOUNT_PROPS = {
    id: null
};

export const createExternalAccount = accountProps => {
    return dispatchPromise({
        type: 'EXTERNAL_ACCOUNT_CREATE_REQUESTED',
        payload: {
            account: Object.assign({}, DEFAULT_ACCOUNT_PROPS, accountProps, {
                id: uuidv4()
            })
        }
    });
}

export const fetchExternalAccounts = all => fetchResources('EXTERNAL_ACCOUNTS_FETCH_REQUESTED', {}, all);

export const removeExternalAccount = accountId => {
    return dispatchPromise({
        type: 'EXTERNAL_ACCOUNT_REMOVE_REQUESTED',
        payload: {
            accountId
        }
    });
}

export const createExternalAccountTeam = accountProps => {
    return dispatchPromise({
        type: 'EXTERNAL_ACCOUNT_CREATE_TEAM_REQUESTED',
        payload: {
            account: Object.assign({}, DEFAULT_ACCOUNT_PROPS, accountProps, {
                id: uuidv4()
            })
        }
    });
}

export const fetchExternalAccountsTeam = all => fetchResources('EXTERNAL_ACCOUNTS_TEAM_FETCH_REQUESTED', {
    team: true
}, all);

export const removeExternalAccountTeam = accountId => {
    return dispatchPromise({
        type: 'EXTERNAL_ACCOUNT_TEAM_REMOVE_REQUESTED',
        payload: {
            accountId
        }
    });
}